export default {
  title: 'Impostos e Moeda',
  subtitle: 'Configure as categorias fiscais utilizadas para definir os preços dos itens do menu.',
};
